import classNames from '../../../../../../_virtual/index.mjs';
import React__default from 'react';
import Typography from '../atoms/Typography.mjs';
import modules_35eb8564 from './Badge.module.css.mjs';

const Badge = ({ className, children })=>/*#__PURE__*/ React__default.createElement("div", {
        className: classNames(modules_35eb8564.badge, className)
    }, /*#__PURE__*/ React__default.createElement(Typography, {
        variant: "helper"
    }, children));

export { Badge };
//# sourceMappingURL=Badge.mjs.map
